import { Component, OnDestroy, OnInit } from '@angular/core';
import { map, Subject, takeUntil } from 'rxjs';
import { BannerModel } from 'src/app/models/banner.model';
import { BannerService } from 'src/app/services/banner.service';
import { EventService } from 'src/app/services/event.service';
import { SwiperOptions } from 'swiper';
import { SwiperConfig } from '../../../config/swiper.config';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '../../../services/alert.service';
import { AuthService } from '../../../services/auth.service';
import { MyProfileService } from '../../../services/my-profile.service';
import { environment } from 'src/environments/environment';
import { HeaderService } from '../../../services/header.service';
import { select, Store } from '@ngrx/store';
import { LocationSelectors } from 'src/app/store/location/selectors';
import { StateModel } from 'src/app/models/state.model';
import { EventActions } from 'src/app/store/pdv/actions';
import { EventSelectors, PdvSelectors } from 'src/app/store/pdv/selectors';
import { HelperService } from 'src/app/services/helper.service';
import { EventModel } from 'src/app/models/event.model';

declare const geoplugin_regionCode: any;
declare const window: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  public banners?: BannerModel[];
  public events!: any[];
  public bannersSwiperConfig: SwiperOptions = SwiperConfig.banners;
  public categoriesSwiperConfig: SwiperOptions = SwiperConfig.categories;
  public eventsSwiperConfig: SwiperOptions = SwiperConfig.events;
  public unsubscribe$ = new Subject();
  public showEventsTag: boolean = false;
  public selectedCategory?: string | null;
  public selectedMonth?: string | null;
  public comissionerMode?: boolean = false;
  public categories: any[] = [
    { id: 'shows-e-festas', name: 'Shows e Festas', icon: '../../../../assets/images/eventos-e-shows.webp' },
    { id: 'esportes', name: 'Esportes', icon: '../../../../assets/images/esporte.webp' },
    { id: 'teatros-e-cinema', name: 'Teatros e Cinema', icon: '../../../../assets/images/teatro-e-cinema.webp' },
  ]

  public hideCategoryShowMonth: boolean = false
  public showClubsShield: boolean = false
  public hideShields: boolean = false

  public showPub: boolean = true
  public showTime = true
  public months: any[] = []
  public loading: boolean = false
  public eventsIsa: any[] = [ 
    // {
    //   name: "LET'S VIBE",
    //   address: "Estacionamento Estádio Nilton Santos",
    //   date: "2024-03-18T21:30:00.000Z",
    //   state: "TO",
    //   city: "Palmas",
    //   uf: "TO",
    //   redirectToExternalLink: "https://www.ingressosa.com/lets-vibe",
    //   image: "https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/event/5b779198-4d45-4e8e-b857-5ac81838a4ab-imagePDV.jpg?1733753859823"
    // },
    // {
    //   name: "DE MESA EM MESA - CAMPO GRANDE",
    //   address: "BOSQUE DOS IPÊS",
    //   date: "2024-03-22T20:00:00.000Z",
    //   state: "MS",
    //   city: "Campo Grande",
    //   uf: "MS",
    //   redirectToExternalLink: "https://ingressosa.com/de-mesa-em-mesa-campo-grande",
    //   image: "https://static-meubilhete.s3.dualstack.us-east-1.amazonaws.com/event/9a54ba0f-54f5-4b37-ad39-11c7dc415b8a-imagePDV.jpg?1732388563057"
    // }
  ]


  public selectedTeam: any = []
  public isaTeams = [
    { name: ["aparecidense", "associação atlética aparecidense","a.a. aparecidense", "aa aparecidense", "aaa", "aparecidense fc", "aparecidense f.c."], image: '../../../../assets/times/aparecidense.png', width: 81, class: 'ms-2 me-3' },
    { name: ["anápolis", "anápolis f.c.", "anápolisfc", "anapolisfc", "anápolis fc"], image: '../../../../assets/times/anapolis.png', width: 79, class: 'ms-2 me-3' },
    { name: ["treze", "treze .f.c", "treze fc"], image: '../../../../assets/times/treze.png', width: 81, class: 'ms-2 me-3' },
    { name: ["são bento", "e.c. são bento", "ecsaobento", "ecsãobento", "sãobento","saobento", "ec são bento", "e.c.são bento", "esporte clube são bento"], image: '../../../../assets/times/sao_bento.png', width: 81, class: 'ms-2 me-2' },
    { name: ["dtc", "tdc", "trem desportivo clube", "trem desportivo", "trem clube"], image: '../../../../assets/times/trem.jpg', width: 101, class: 'ms-2 me-3' },
    { name: ["mtc", "mc", "motoclube", "moto", "motoclub", "moto clube", "moto club"], image: '../../../../assets/times/motoclub.png', width: 73, class: 'ms-2 me-3' },
    { name: ["goiânia e.c.", "goiânia ec", "goiânia", "goiania ec", "goiânia e.c.", "goiania"], image: '../../../../assets/times/goiania.png', width: 73, class: 'ms-2 me-3' },
    { name: ["mirassol", "mirassolfc", "mirassol f.c.", "mfc", "mirasol fc"], image: '../../../../assets/times/mirassol.png', width: 71, class: 'ms-2 me-3' },
    { name: ["e.c.vitória",  "ecvitória", "e.c. vitória", "ec vitória", "vitória"], image: '../../../../assets/times/vitoria_logomarca.png', width: 121, class: 'ms-2 me-2' },
    { name: ["vila nova", "vilanova", "vila nova f.c.", "vila nova fc"], image: '../../../../assets/times/vilanova.png', width: 61, class: 'ms-2 me-4 mt-2' },
    { name: ["atlético go", "atleticogoianiense", "atléticogoianiense", "atlético-go", "atlético goianiense", "acg"], image: '../../../../assets/times/atletico_goianiense.png', width: 44, class: 'ms-2 me-2' },
    { name: ["remo", "clubedoremo", "clube do remo"], image: '../../../../assets/times/remo.png', width: 101, class: 'ms-2 me-3' },
    { name: ["paysandu", "paysandu f.c.", "paysandu fc"], image: '../../../../assets/times/paysandu.png', width: 71, class: 'ms-2 me-3' },
    { name: ["guarani", "guarani f.c.","guarani fc"], image: '../../../../assets/times/guarani.png', width: 71, class: 'ms-2 me-3' },
    { name: ["gama", "sociedade esportiva do gama", "se gama", "s.e. gama"], image: '../../../../assets/times/gama.png', width: 81, class: 'ms-2 me-3' },
    { name: ["santa cruz", "santacruz", "santa cruz f.c.","santa cruz fc"], image: '../../../../assets/times/santa_cruz.png', width: 71, class: 'ms-2 me-3' },
    { name: ["flamengo", "clube de regatas do flamengo", "cr flamengo", "c.r. flamengo"], image: '../../../../assets/times/flamengo.png', width: 61, class: 'ms-2 me-3' },
    { name: ["vasco", "vasco da gama", "c.r. vasco da gama", "cr vasco da gama", "cr vasco", "c.r vasco"], image: '../../../../assets/times/vasco.png', width: 61, class: 'ms-2 me-3' },
    { name: ["botafogo", "botafogo futebol e regatas", "boafogo f.r.", "botafogo fr"], image: '../../../../assets/times/botafogo.png', width: 71, class: 'ms-2 me-3' },
    { name: ["fluminense", "fluminense f.c.", "fluminense fc"], image: '../../../../assets/times/fluminense.png', width: 71, class: 'ms-2 me-3' },
    { name: ["palmeiras", "se palmeiras", "sociedade esportiva palmeiras"], image: '../../../../assets/times/palmeiras.png', width: 81, class: 'ms-2 me-3' },
    { name: ["corinthians", "e.c corinthians paulista", "e.c corinthians", "ec corinthians", "ec corinthians paulista"], image: '../../../../assets/times/corinthians.png', width: 71, class: 'ms-2 me-3' },
    { name: ["são paulo", "sãopaulo", "saopaulo", "spfc", "são paulo f.c.", "são paulo fc"], image: '../../../../assets/times/sao_paulo.png', width: 71, class: 'ms-2 me-3' },
    { name: ["santos", "santos fc", "santosfc", "santos f.c."], image: '../../../../assets/times/santos.png', width: 81, class: 'ms-2 me-3' }
  ];

  public goianaoTeams = [
    { name: ["anápolis"], width: 71, image: "../../../../assets/times/anapolis.png", class: "ms-2 me-2" },
    { name: ["passaporte abecat", "abecat"], width: 77, image: "../../../../assets/times/abecat.jpg", class: "ms-2 me-2" },
    { name: ["associação atlética aparecidense"], width: 81, image: "../../../../assets/times/associacao-atletica-aparecidense.gif", class: "ms-2 me-2" },
    { name: ["atlético go", "atlético-go", "atlético goianiense", "acg"], width: 77, image: "../../../../assets/times/atletico-go.jpg", class: "ms-2 me-2" },
    { name: ["crac"], width: 77, image: "../../../../assets/times/crac.gif", class: "ms-2 me-2" },
    { name: "goianésia", width: 71, image: "../../../../assets/times/goianesia.gif", class: "ms-2 me-2" },
    { name: ["goiânia", "e.c.goiânia", "e.c. goiânia", "ec goiânia"], width: 71, image: "../../../../assets/times/goiania.gif", class: "ms-2 me-2" },
    { name: ["goiás"], width: 71, image: "../../../../assets/times/goias.gif", class: "ms-2 me-2" },
    { name: ["goiatuba"], width: 71, image: "../../../../assets/times/goiatuba.gif", class: "ms-2 me-2" },
    { name: ["inhumas"], width: 71, image: "../../../../assets/times/inhumas.jpg", class: "ms-2 me-2" },
    { name: ["jataiense"], width: 71, image: "../../../../assets/times/jataiense.gif", class: "ms-2 me-2" },
    { name: ["vila nova", "vila nova f.c."], width: 61, image: "../../../../assets/times/vilanova.png", class: 'ms-2 me-4 mt-2' },
  ]
  public utm: string|undefined = ""
  showSwiperStates = environment.showSwiperStates;
  showBeOurPartner = environment.showBeOurPartner;
  public showLgpd = environment.showLgpd;

  cities$ = this.store.pipe(select(LocationSelectors.selectCities));
  pdv$ = this.store.pipe(select(PdvSelectors.selectCompany))

  pdvLoader$ = this.store.pipe(select(PdvSelectors.selectLoader));

  public get clientUF(): string {
    try {
      return geoplugin_regionCode();
    } catch (e) {
      return 'GO';
    }
  }

  constructor(
    private bannerService: BannerService,
    private eventService: EventService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private helperService: HelperService,
    private authService: AuthService,
    private myProfileService: MyProfileService,
    private store: Store,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.loadBanners();

    if (this.authService.getProducer() != null && this.authService.getProducer().user != null && this.authService.getProducer().user.producerOwnerId != null && this.authService.getProducer().user.producerOwnerId == "28164152-03a1-4bce-b96f-9fe223d32d98") {
      this.showPub = false
      this.removePub()
    }

    this.activatedRoute.queryParams.subscribe((params) => {      
      this.utm = this.helperService.getUtm(params)      
    })

    this.hideCategoryShowMonth = environment.hideCategoryShowMonth

    this.showClubsShield = environment.showClubsShieldsFilter
    // if (this.showPub == true){
    this.loadScript();
    // }

    this.pdv$.subscribe((res) => {
      if ("c51c9b70-b692-42cb-9821-0945f72f8a2e" ==  res?.id) {
        this.loadMbScript()
      }    
    })

    if (this.authService.getCustomer() != null
      && this.authService.getCustomer().modeComissioner != null
      && this.authService.getCustomer().modeComissioner == true) {
      this.comissionerMode = true;
      this.myProfileService.defineModeComissioner(this.comissionerMode as boolean);
      if (this.hideCategoryShowMonth == false) {
        this.loadEventCategories();
      } else {
        this.loadEventMonths();
      }
    }

    this.myProfileService.getComissioner().subscribe((res: any) => {
      this.comissionerMode = res;
      if (this.hideCategoryShowMonth == false) {
        this.loadEventCategories();
      } else {
        this.loadEventMonths();
      }
    });


  }


  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();

    this.removePub()
  }

  removePub() {
    for (let i = 0; i < document.getElementsByTagName("script").length; i++) {
      if (document.getElementsByTagName("script")[i].id != null) {
        if (document.getElementsByTagName("script")[i].id == "CleverCoreLoader79488") {
          document.getElementsByTagName("script")[i].src = ""
          document.getElementsByTagName("script")[i].id = ""
        }
      }
    }

    for (let i = 0; i < document.getElementsByTagName("div").length; i++) {
      if (document.getElementsByTagName("div")[i].id != null) {
        if (document.getElementsByTagName("div")[i].id.indexOf("clever-79488-") > -1) {
          document.getElementsByTagName("div")[i].remove()
        }
      }
    }
  }

  public selectCategory(category: string) {
    this.selectedCategory = this.selectedCategory != category ? category : null;
  }

  sameArray(arr1, arr2) {
    if (arr1.length != arr2.length) {
      return false;
    }

    let same = true
    arr1.forEach(function (ele, i) {

      if (ele != arr2[i]) {
        same = false
      }
    })

    return same
  }


  filterByTeam(team) {
    if (this.sameArray(this.selectedTeam, team) == true) {
      this.selectedTeam = []
    } else {
      this.selectedTeam = team
    }
  }

  public selectMonth(month: string) {
    this.selectedMonth = this.selectedMonth != month ? month : null;
  }

  loadScript() {
    if (environment.enableCleverAdvertising) {
      (function (document, window) {
        var a, c = document.createElement("script"), f = window.frameElement;

        c.id = "CleverCoreLoader79488";
        c.src = "https://scripts.cleverwebserver.com/22de7571ff776767c3f3385a9138a14d.js";

        c.async = !0;
        c.type = "text/javascript";
        c.setAttribute("data-target", window.name || (f && f.getAttribute("id")));
        c.setAttribute("data-callback", "put-your-callback-function-here");
        c.setAttribute("data-callback-url-click", "put-your-click-macro-here");
        c.setAttribute("data-callback-url-view", "put-your-view-macro-here");


        try {
          a = parent.document.getElementsByTagName("script")[0] || document.getElementsByTagName("script")[0];
        } catch (e) {
          a = !1;
        }

        a || (a = document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]);
        a.parentNode.insertBefore(c, a);
      })(document, window);
    }
  }


  loadMbScript() {
    (function(w,d,s,l,i){
      w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
      (j as any).async=true;
      (j as any).src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f?.parentNode?.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-PPCG2CSQ');
  }


  /*
    existindo, indica que cliente está em uma rota de tags.
    a rota de tags lista apenas o eventos pertecentes a esta tag em
    uma url personalizada
  */
  onRouterFilter(): void {
    let tag = this.activatedRoute.snapshot.queryParamMap.get('tag');

    //this.events = [];
    if (tag != null && tag !== '') {
      this.eventService.getSiteEvents().subscribe((res: any) => {
        this.events! = []
        this.eventsIsa = []
        if (res != null && res?.length) {
          res.forEach((event: any) => {
            if (event.tags.length > 0 && event.tags[0].tag == tag) {
              this.showEventsTag = true;
              if (event.tags[0].tag == "sesi") {
                this.showTime = false
              }
              if (event.tags[0].logo != null) {
                this.headerService.defineLogoTag(event.tags[0].logo)
              }
              this.events![this.events!.length] = event;
              this.hideShields = true
            }
          });
        }
        if (this.events!.length == 0) {
          this.showEventsTag = false;
          if (tag?.toLowerCase() != "sesi") {
            this.alertService.toast({ icon: 'error', title: 'Nenhum evento encontrado', text: 'Nenhum evento encontrado para a tag ' + tag });
          }
        }
      });
    }
  }

  private loadBanners(): void {
    this.bannerService.getAll()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(banners => {
        this.banners = banners.sort((a: BannerModel, b: BannerModel) => { if (a.uf == this.clientUF) return -1; else return 1; });
      });
  }

  private loadEventCategories(): void {
    let params;


    if (this.comissionerMode == true) {
      params = { comissionerId: this.authService.getCustomer().comissionerId };
    }

    if (this.events != null) {
      this.events.length = 0;
    }

    this.eventService.groupByCategories(params)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((events) => {
        this.events = events.filter(
          (event) => event.id !== 'f6ae00d6-3f76-4abd-9c03-3676e4e33a38' && event.id != "ec026c2c-4ddb-4549-8ac3-547cb544ff4e"
        );
        const eventsSesi: EventModel[] = []
        this.events = this.events.filter((event) => {
          if (event["name"].toLowerCase().indexOf("sesi ") <= -1 && event["address"].toLowerCase().indexOf("sesi lab") <= -1) {
            return event
          } else {
            eventsSesi[eventsSesi.length] = event
          }
        })

        const originalEvents = this.events.slice();
        const filteredEvents$ = this.store.select(EventSelectors.selectFilteredEvents);
        const filteredState$ = this.store.select(EventSelectors.selectFilteredState);
        const searchedEvent$ = this.store.select(EventSelectors.selectSearchedEvent);
        
        searchedEvent$.subscribe((res) => {
          if (res != "") {
            filteredEvents$.subscribe((res) => {              
              if (res != null ) {
                if (res.length >=1) {                
                  this.events = res as any
                }
              }
            })
          } else {
            filteredState$.subscribe((res) => {
              if (res != null) {
                this.events = originalEvents.concat(eventsSesi)
              } else {
                this.events = originalEvents
              }
            })
          }
        })
       
        this.onRouterFilter();
      });
  }

  setSelectedState(filteredState: StateModel) {
    this.store.dispatch(EventActions.filterEventsByState({ filteredState }));
    window.scroll(0, 203);
  }

  private loadEventMonths(): void {
    let params;


    if (this.comissionerMode == true) {
      params = { comissionerId: this.authService.getCustomer().comissionerId };
    }

    if (this.events != null) {
      this.events.length = 0;
    }
    this.loading = true
    this.eventService.groupByMonths(params)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((events) => {
        let months: any[] = []
        events.forEach((event) => {
          this.loading = false
          let number = event.dates[0].split("-")[1]
          let name = new Date(event.dates[0]).toLocaleString("pt-BR", { month: "long" })
          let year = new Date(event.dates[0]).getFullYear()
          let monthExists = months.filter((month) => {
            if (month.number == number) {
              return month
            }
          })
          if (monthExists.length <= 0) {
            months[months.length] = { number: number, name: name, year: year }
          }
        })

        this.months = months

        this.months = this.months.sort((a, b) => {
          if (a.year !== b.year) {
            return a.year - b.year;
          }

          return months.indexOf(a.month) - months.indexOf(b.month)
        });
        this.events = events.filter(
          (event) => event.id !== 'f6ae00d6-3f76-4abd-9c03-3676e4e33a38'
        );
        this.onRouterFilter();
      });
  }
}
